import { colors } from '@src/common/styles/valueTokens';
import { OrderStatus } from '@src/orders/domain/Order';
import { PermitStatus } from '@src/orders/domain/PermitApplication';

type Colors = {
  color: string;
  border: string;
  background: string;
};

export const orderStatusColors: Record<OrderStatus, Colors> = {
  [OrderStatus.DRAFT]: {
    color: colors.text.secondary,
    border: colors.border.primary,
    background: colors.neutral[100],
  },
  [OrderStatus.AUTOMATIC_DRAFT]: {
    color: colors.text.secondary,
    border: colors.border.primary,
    background: colors.neutral[100],
  },
  [OrderStatus.NEW]: {
    color: colors.utility.purple[700],
    border: colors.utility.purple[200],
    background: colors.utility.purple[50],
  },
  [OrderStatus.ACTIVE]: {
    color: colors.utility.success[700],
    border: colors.utility.success[200],
    background: colors.utility.success[50],
  },
  [OrderStatus.HOLD]: {
    color: colors.utility.warning[700],
    border: colors.utility.warning[200],
    background: colors.utility.warning[50],
  },
  [OrderStatus.CANCELLED]: {
    color: colors.utility.red[700],
    border: colors.utility.red[200],
    background: colors.utility.red[50],
  },
  [OrderStatus.TO_REVIEW]: {
    color: colors.utility.orange[700],
    border: colors.utility.orange[200],
    background: colors.utility.orange[50],
  },
  [OrderStatus.TO_INVOICE]: {
    color: colors.utility.pink[700],
    border: colors.utility.pink[200],
    background: colors.utility.pink[50],
  },
  [OrderStatus.INVOICED]: {
    color: colors.utility.pink[700],
    border: colors.utility.pink[200],
    background: colors.utility.pink[50],
  },
  [OrderStatus.MODIFY_INVOICE]: {
    color: colors.utility.pink[700],
    border: colors.utility.pink[200],
    background: colors.utility.pink[50],
  },
  [OrderStatus.COMPLETED]: {
    color: colors.utility.blue[700],
    border: colors.utility.blue[200],
    background: colors.utility.blue[50],
  },
  [OrderStatus.ARCHIVED]: {
    color: colors.primary[10],
    border: colors.state.primary.medium,
    background: colors.state.primary.light,
  },
};

export const permitStatusColors: Record<PermitStatus, Colors> = {
  [PermitStatus.NEW]: {
    color: colors.utility.purple[700],
    border: colors.utility.purple[200],
    background: colors.utility.purple[50],
  },
  [PermitStatus.WITH_JURISDICTION]: {
    color: colors.utility.success[700],
    border: colors.utility.success[200],
    background: colors.utility.success[50],
  },
  [PermitStatus.ISSUED]: {
    color: colors.utility.blue[700],
    border: colors.utility.blue[200],
    background: colors.utility.blue[50],
  },
  [PermitStatus.ISSUED_ERROR]: {
    color: colors.utility.error[700],
    border: colors.utility.error[200],
    background: colors.utility.error[50],
  },
  [PermitStatus.DENIED]: {
    color: colors.utility.error[700],
    border: colors.utility.error[200],
    background: colors.utility.error[50],
  },
  [PermitStatus.CANCELLED]: {
    color: colors.primary[10],
    border: colors.state.primary.medium,
    background: colors.state.primary.light,
  },
  [PermitStatus.HOLD]: {
    color: colors.utility.warning[700],
    border: colors.utility.warning[200],
    background: colors.utility.warning[50],
  },
};
